import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MarkdownViewerComponent } from '@examdojo/core/ui/markdown-viewer';

import type { ExplainItem } from './explain-table.model';

@Component({
  selector: 'dojo-explain-table',
  standalone: true,
  imports: [MatExpansionModule, MarkdownViewerComponent],
  templateUrl: './explain-table.component.html',
  styleUrl: './explain-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExplainTableComponent {
  readonly items = input.required<ExplainItem[]>();
  readonly highlightedId = model<string | null>(null);

  /** Column headers — customisable per chart type. */
  readonly headerLabel = input<string>('Part');
  readonly headerDescription = input<string>('What it represents');
  readonly headerValue = input<string>('Value');
}
